import { API, getToken } from "@/lib/api";

// Resolve a media object {type, value} into a usable src URL.
export function mediaUrl(media) {
  if (!media || !media.value) return null;
  if (media.type === "external") return media.value;
  const token = getToken();
  return `${API}/files/${media.value}${token ? `?auth=${token}` : ""}`;
}
